function OurVision() {
  return (
    <>
      <div className="page-title" data-aos="fade">
        <div className="container">
          <nav className="breadcrumbs">
            <ol>
              <li><a href="index.html">Home</a></li>
              <li className="current">Our Vision</li>
            </ol>
          </nav>
          <h1>Our Vision</h1>
        </div>
      </div>

      <section id="vision" className="team section">
        <div className="container">
          <p>
            Our vision at CA Sanjay Prasad & Associates is to be a leading chartered accountancy firm known for excellence, integrity, and innovation. We aspire to be the most trusted financial advisors to our clients by delivering high-quality, future-ready solutions that empower them to achieve sustained growth and success.
          </p>
          <p>
            We envision building a firm that not only supports the financial health of businesses and individuals but also contributes positively to the evolving landscape of accounting and advisory services through knowledge, technology, and strategic insight.
          </p>
          <p>
            By fostering a culture of continuous learning, ethical practices, and client-centric values, we aim to set benchmarks in the profession and inspire confidence among our stakeholders.
          </p>
        </div>
      </section>
    </>
  );
}

export default OurVision;
